import {observer} from "mobx-react-lite";
import pageBuilderStore from "../../stores/pageBuilderStore";
import glideBarManager from "../../stores/glidebar-manager";
import {Images, PanelsTopLeft, Shapes} from "lucide-react";

/**
 * EditorToolbar is the vertical rightmost toolbar for PageBuilder,
 * providing quick access to open and switch between the main Sidebar panels:
 * Content, Body Properties, and Image Library.
 *
 * Features:
 * - Renders vertically with one button for each major panel:
 *   - **Content** (Shapes icon): For blocks and templates.
 *   - **Body** (PanelsTopLeft icon): For page layout and appearance.
 *   - **Images** (Images icon): For image upload and management.
 * - Highlights the active panel and allows toggling panels on/off.
 * - Interaction is fully managed via the MobX `pageBuilderStore`.
 *
 * @component
 * @remarks
 * - Internal, single-use component; not intended for reuse outside PageBuilder.
 * - No props; all state comes from and is set through the MobX store.
 * - New panels or icons may be added as features expand.
 *
 * @example
 * // Used as the rightmost vertical toolbar in the main PageBuilder layout:
 * <EditorToolbar />
 */
export default observer(function EditorToolbar () {
	return (
		<div className="w-[50px] h-[800px] bg-gray-50 flex flex-col items-center border-l border-gray-300 z-20"
		>
			<div className="flex flex-col">
				<button
					title="Content"
					className={`w-12 h-12 shadow flex items-center justify-center hover:bg-gray-200 ${
						pageBuilderStore.activePanel === 'content' ? 'bg-blue-100 border-l-2 border-blue-500' : 'bg-white'
					}`}
					onClick={() => {
						glideBarManager.hideGlideBar();
  					glideBarManager.setIsEditingHeading(false);
	  				glideBarManager.setIsEditingText(false);
						pageBuilderStore.setActivePanel('content');
					}}
				>
					<Shapes size={24} strokeWidth={1.5} />
				</button>
				<button
					title="Body"
					className={`w-12 h-12 shadow flex items-center justify-center hover:bg-gray-200 ${
						pageBuilderStore.activePanel === 'body' ? 'bg-blue-100 border-l-2 border-blue-500' : 'bg-white'
					}`}
					onClick={() => {
						glideBarManager.hideGlideBar();
					  glideBarManager.setIsEditingHeading(false);
					  glideBarManager.setIsEditingText(false);
						pageBuilderStore.setActivePanel('body');
					}}
				>
					<PanelsTopLeft size={24} strokeWidth={1.5} />
				</button>
				<button
					title="Images"
					className={`w-12 h-12 shadow flex items-center justify-center hover:bg-gray-200 ${
						pageBuilderStore.activePanel === 'images' ? 'bg-blue-100 border-l-2 border-blue-500' : 'bg-white'
					}`}
					onClick={() => { 
						glideBarManager.hideGlideBar();
					  glideBarManager.setIsEditingHeading(false);
					  glideBarManager.setIsEditingText(false);
						pageBuilderStore.setActivePanel('images'); 
					}}
				>
					<Images size={24} strokeWidth={1.5} />
				</button>
			</div>
		</div>
	);
});
